// extracted by mini-css-extract-plugin
export var actionButton = "_i0-t";
export var buttonContainer = "_i0-0";
export var buttonContainer2 = "_i0-1";
export var buttonSection = "_i0-2";
export var details = "_i0-3";
export var dropdownItem = "_i0-5";
export var dropdownItemsContainer = "_i0-4";
export var fileInput = "_i0-r";
export var headerButton = "_i0-6";
export var icon = "_i0-7";
export var input = "_i0-8";
export var macroListItem = "_i0-9";
export var mainContent = "_i0-a";
export var microText = "_i0-b";
export var modal = "_i0-w";
export var optionsButton = "_i0-c";
export var paperclip = "_i0-s";
export var pillContent = "_i0-d";
export var preview = "_i0-e";
export var preview2 = "_i0-f";
export var quillEditor = "_i0-q";
export var selectedMacro = "_i0-g";
export var sidebar = "_i0-h";
export var sidebarHeader = "_i0-j";
export var sidebarList = "_i0-i";
export var sidebarListItem = "_i0-k";
export var sidebarSearch = "_i0-l";
export var snoozeDurationWrapper = "_i0-v";
export var statusPillContainer = "_i0-m";
export var tagsContainer = "_i0-n";
export var unselectedMacro = "_i0-o";
export var variable = "_i0-u";
export var wrapper = "_i0-p";